// Настройки конкретного брокера поверх бренда.
//
// Бренд (REACT_APP_BRAND) — это палитра и логотип, и Horizon общий у Rox и JetQ.
// А вот что брокер продаёт и как называется — у каждого своё, поэтому отдельная
// переменная сборки:
//
//   REACT_APP_TENANT=        → как было (DOSCAR, Rox)
//   REACT_APP_TENANT=jetq    → JetQ: БУ-авто принимает только по договору
//                              поручения, своё название и иконка вкладки браузера
//   REACT_APP_TENANT=mega    → MEGA: как JetQ (серый дилер, только БУ-авто по
//                              договору поручения), своё название вкладки и без значка
import { CAR_ORIGIN_TYPES, CONSIGNMENT_ORIGINS } from '../constants/carOrigin';
import { BANKS } from '../constants';

export const TENANTS = {
  jetq: {
    title: 'JetQ',
    // public/assets — иконка вкладки; у остальных остаётся apple-touch-icon.png.
    favicon: '/assets/jetq-icon.png',
    // Новые авто JetQ продаёт — разделы в «Автомобилях» и «Продажах» на месте,
    // как у DOSCAR (вернули 14.10.2026 по просьбе Димы).
    // Машины с пробегом JetQ принимает только по договору поручения; на новые
    // это ограничение не распространяется — список происхождения показывается
    // лишь в режиме «БУ авто».
    carOrigins: CONSIGNMENT_ORIGINS,
    // Серый дилер торгует любыми марками: менеджер заводит марку, модель и
    // комплектацию прямо в карточке авто, не дожидаясь администратора.
    managersAddDictionaries: true,
    // Трёхсторонний договор (Агент — Продавец — Покупатель) пока только у DOSCAR.
    // У JetQ все машины по договору поручения — без выключателя шаг встал бы в каждую сделку.
    tripartiteContract: false,
    shortForms: true,
  },
  // Партнёры-серые дилеры заводятся по образцу MEGA: отличается только название
  // вкладки. Пока у всех одинаковый набор — только БУ-авто по договору поручения,
  // марки и модели менеджеры заводят сами. Если кто-то начнёт продавать новые
  // авто, у него появятся свои carOrigins, как было с JetQ.
  evmst: {
    title: 'EV-MASTER',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
  bayc: {
    title: 'Bay Cars',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
  tswg: {
    title: 'TSW Group',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
  drvpt: {
    title: 'Drive Point Auto',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
  jsavto: {
    title: 'JS Avto',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    // На старте партнёр работает только с этими тремя банками: с остальными
    // договора нет, и отмеченная галочка слала бы заявку в никуда.
    bankIds: [BANKS.BCK, BANKS.FREEDOM, BANKS.SHINHAN],
    shortForms: true,
  },
  // Auto Arena (Алматы) — седьмой партнёр, развёрнут 28.10.2026 по образцу
  // JS Avto: только БУ-авто по договору поручения и те же три банка.
  arena: {
    title: 'Auto Arena',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    bankIds: [BANKS.BCK, BANKS.FREEDOM, BANKS.SHINHAN],
    shortForms: true,
  },
  // Empire (Алматы) — восьмой партнёр, развёрнут 29.10.2026 по образцу Arena.
  // На старте банк был один (Шинхан): с остальными не было договора. С 03.11.2026
  // те же три банка, что у Arena, Tulpar и JS Avto.
  empire: {
    title: 'Empire',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    bankIds: [BANKS.BCK, BANKS.FREEDOM, BANKS.SHINHAN],
    shortForms: true,
  },
  // Tulpar — девятый партнёр, развёрнут 29.10.2026 по образцу Arena: только
  // БУ-авто по договору поручения и те же три банка.
  tulpar: {
    title: 'Tulpar',
    favicon: null,
    usedCarsOnly: true,
    // В договоре поручения ДЦ не сужаем до АСП: DCG Esil заведён салоном (used=false)
    // и иначе не выбирается. Остальным брокерам список по-прежнему только из АСП.
    consignmentAnyDc: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    bankIds: [BANKS.BCK, BANKS.FREEDOM, BANKS.SHINHAN],
    shortForms: true,
  },
  mega: {
    title: 'MEGA',
    // Своей иконки у партнёра нет, а наш логотип на его вкладке лишний:
    // null — это «убрать значок», а не «оставить как есть» (см. applyTenant).
    favicon: null,
    // MEGA — серый дилер, как JetQ: новых авто нет, машины только по договору
    // поручения, дилерский центр не привязан к марке.
    usedCarsOnly: true,
    carOrigins: CONSIGNMENT_ORIGINS,
    tripartiteContract: false,
    managersAddDictionaries: true,
    shortForms: true,
  },
};

export const resolveTenant = (value) => {
  const key = String(value || '').trim().toLowerCase();
  return TENANTS[key] || null;
};

export const tenant = resolveTenant(process.env.REACT_APP_TENANT);

// Разделы «Новые авто» в меню «Автомобили» и «Продажи».
const NEW_CARS_PATHS = ['/cars/new', '/deals/new'];

// Разделы «Продаж», которые есть только у DOSCAR: Halyk Market подключён
// к нему одному, а мобильное приложение, из которого клиент подаёт заявку
// сам, — тоже наше. У партнёров (серых дилеров) со своим tenant их нет.
const DOSCAR_ONLY_PATHS = ['/deals/halyk', '/deals/app', '/deals/full-payment'];

// Раздел «Продаж» для поручения с первичной регистрацией — только у серых дилеров.
export const FIRST_REG_DEALS_PATH = '/deals/first-registration';

/**
 * «Поручение, первичная регистрация» (происхождение 7 и раздел продаж) — только у серых
 * дилеров: у брокера со своим tenant, в чьём списке carOrigins есть это происхождение.
 * У DOSCAR и Rox tenant'а нет, там происхождения и раздела нет.
 */
export const firstRegistrationEnabled = (current = tenant) =>
  current?.carOrigins?.includes(CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG) === true;

/** Происхождение доступно брокеру: «первичка» (7) — только если она включена. */
export const originAvailable = (origin, current = tenant) =>
  origin !== CAR_ORIGIN_TYPES.CONSIGNMENT_FIRST_REG || firstRegistrationEnabled(current);

/**
 * Пункты меню «Автомобили» и «Продажи»: у брокера только с БУ-авто «Новые авто» убираем,
 * а разделы «Халык» и «Из приложения» оставляем только у DOSCAR (без tenant).
 * Раздел «первичка» — наоборот, только у серых дилеров.
 */
export const usedOnlyMenuChildren = (children, current = tenant) => {
  const visible = children.filter((item) => item.path !== FIRST_REG_DEALS_PATH || firstRegistrationEnabled(current));
  return current
    ? visible.filter(
        (item) =>
          !DOSCAR_ONLY_PATHS.includes(item.path) &&
          !(current.usedCarsOnly && NEW_CARS_PATHS.includes(item.path))
      )
    : visible;
};

/**
 * Обучение новичка (тур с подсказками и чек-лист) — только у DOSCAR и Rox,
 * где своего tenant нет. Шаги написаны под разделы DOSCAR: у брокеров
 * партнёров половины из них нет, и тур водил бы человека по пустым местам.
 */
export const onboardingEnabled = (current = tenant) => !current;

/**
 * Банки, которые брокер показывает в выборе. У брокера без своего списка — все,
 * кто подходит по типу машины (БУ-авто ограничено USED_CAR_BANK_IDS).
 */
export const allowedTenantBankIds = (ids, current = tenant) => {
  if (!Array.isArray(current?.bankIds)) return ids;
  return Array.isArray(ids) ? ids.filter((id) => current.bankIds.includes(id)) : current.bankIds;
};

/** Варианты «Происхождение автомобиля»: у брокера со своим списком — только они. */
export const allowedOriginOptions = (options, current = tenant) =>
  (current?.carOrigins ? options.filter((option) => current.carOrigins.includes(option.value)) : options).filter(
    (option) => originAvailable(option.value, current)
  );

/** Значок DOSCAR — для DOSCAR и Rox, у которых своего tenant нет. */
const DOSCAR_FAVICON = '/assets/apple-touch-icon.png';

/**
 * Название и иконка вкладки браузера.
 *
 * Значка в public/index.html нет: пока он там стоял, у партнёров логотип DOSCAR
 * успевал показаться до загрузки скрипта и оставался во вкладке (22.10.2026,
 * MEGA). Поэтому ставим его здесь — своим, а партнёрам не ставим вовсе.
 */
export const applyTenant = (doc = document, current = tenant) => {
  if (current?.title) doc.title = current.title;

  // null у партнёра — «значка нет», у DOSCAR и Rox tenant'а нет вовсе — значок свой.
  const favicon = current ? ('favicon' in current ? current.favicon : DOSCAR_FAVICON) : DOSCAR_FAVICON;
  const links = doc.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]');

  if (!favicon) {
    links.forEach((link) => link.remove());
    return;
  }
  if (links.length > 0) {
    links.forEach((link) => link.setAttribute('href', favicon));
    return;
  }
  const link = doc.createElement('link');
  link.setAttribute('rel', 'icon');
  link.setAttribute('href', favicon);
  doc.head.appendChild(link);
};

/** Может ли менеджер заводить марки, модели и комплектации сам (серые дилеры). */
export const managersAddDictionaries = (current = tenant) => current?.managersAddDictionaries === true;

/** Показывать в договоре поручения любые ДЦ, а не только АСП (used=true). */
export const consignmentAnyDcEnabled = (current = tenant) => current?.consignmentAnyDc === true;

/**
 * Короткие формы заявки у серого дилера (включены у всех партнёров, JetQ в том
 * числе; у DOSCAR и Rox формы остаются полными): в карточке клиента не спрашиваем регион
 * (КАТО), язык и контактные данные, в карточке авто — комплектацию, мощность и
 * тип привода.
 *
 * Эти поля нужны либо банкам, которых у партнёра нет (КАТО уходит только в Сапу,
 * Solva и PledgeCar), либо письмам клиенту, которых партнёр не шлёт. Комплектацию
 * без менеджера подставляем сами: без неё авто не добавить в сделку.
 */
export const shortFormsEnabled = (current = tenant) => current?.shortForms === true;

/** Нужен ли шаг «Трёхсторонний договор» в сделках по договору поручения. */
export const tripartiteContractEnabled = (current = tenant) => current?.tripartiteContract !== false;
